import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';
import { generateToken } from '@/lib/auth';

export async function POST(request: NextRequest) {
  try {
    const body = await request.json();
    const { userId } = body;
    
    console.log(`👑 Admin impersonating user: ${userId}`);
    
    if (!userId) {
      return NextResponse.json(
        { error: 'User ID is required' },
        { status: 400 }
      );
    }
    
    // Get user from database
    const user = await db.users.findById(userId);
    if (!user) {
      return NextResponse.json(
        { error: 'User not found' },
        { status: 404 }
      );
    }

    // Check user status
    if (user.status === 'suspended') {
      return NextResponse.json(
        { error: 'Cannot impersonate suspended user' },
        { status: 403 }
      );
    }

    if (user.status === 'deleted') {
      return NextResponse.json(
        { error: 'Cannot impersonate deleted user' },
        { status: 403 }
      );
    }

    // Determine user role based on profiles
    let role = 'user';
    
    // Check if user is a gym owner
    const gymProfiles = await db.gyms.findByOwnerEmail(user.email);
    if (gymProfiles.length > 0) {
      role = 'gym';
    }
    
    // Check if user is a trainer
    const trainerProfiles = await db.trainers.findByOwnerEmail(user.email);
    if (trainerProfiles.length > 0) {
      role = 'trainer';
    }

    // Generate impersonation token
    const token = await generateToken({
      userId: user.id,
      email: user.email,
      role: role,
      impersonatedBy: 'admin' // Mark that this is an impersonation
    });

    console.log(`✅ Admin successfully impersonating: ${user.email} (${role})`);

    return NextResponse.json({
      success: true,
      message: 'Successfully impersonated user',
      token,
      user: {
        id: user.id,
        fullName: user.fullName,
        email: user.email,
        phone: user.phone,
        profilePicture: user.profilePicture || null,
        role: role,
        status: user.status
      },
      impersonated: true
    });

  } catch (error) {
    console.error('❌ Impersonation error:', error);
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    return NextResponse.json(
      { error: 'Failed to impersonate user: ' + errorMessage },
      { status: 500 }
    );
  }
}
